// extracted by mini-css-extract-plugin
module.exports = {"link":"ImageLinkControl_link__E0VRk","image":"ImageLinkControl_image____0XG","title":"ImageLinkControl_title__R8BUG"};